import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function PaymentsFinTechLicenses() {

    return (
        <main className='main'>
            <IntroSection
                title="Payments & FinTech Licenses"
                subtitle="Power Your Digital Finance Business with Global Licensing Solutions"
                description="At Offshore Advisory, we help startups, PSPs, EMIs, MSBs, and FinTech innovators obtain the right licenses to operate legally and scale globally. Whether you’re launching a payment institution, electronic money service, or crypto-payments platform, our team guides you through the licensing process in trusted jurisdictions."
                badges={[
                    "EMI, PSP & MSB Licensing",
                    "Crypto-FinTech Hybrid Solutions",
                    "Banking & Payment Integrations"
                ]}
                buttonText="Request a Payments & FinTech License Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/Payments & FinTech Licenses-hero.png")}
                imageAlt="Payments & FinTech Licenses"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='What is a Payments/FinTech License?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Electronic Money",
                                                text: "Includes EMI/E-Money Institutions to issue and manage digital funds."
                                            },
                                            {
                                                title: "Payment Services",
                                                text: "Payment Service Providers (PSPs) enabling merchant and consumer payments."
                                            },
                                            {
                                                title: "Money Services & Mobile Payments",
                                                text: "Money Services Businesses, wallets, mobile payments, and remittances."
                                            },
                                            {
                                                title: "Merchant & Cross-Border Services",
                                                text: "Payment gateways, merchant services, and cross-border transfers."
                                            },
                                            {
                                                title: "Crypto-Fiat Solutions",
                                                text: "Depending on jurisdiction, support for hybrid crypto-payment solutions."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Top Jurisdictions for Payments & FinTech"
                        blocks={[
                            {
                                title: "Malta",
                                items: [
                                    { text: "EMI & PSP licenses under MFSA, EU-recognized." }
                                ]
                            },
                            {
                                title: "Cyprus",
                                items: [
                                    { text: "EMI/PSP licenses regulated by Central Bank of Cyprus, strong EU credibility." }
                                ]
                            },
                            {
                                title: "Mauritius",
                                items: [
                                    { text: "PSP and FinTech sandbox licensing, popular for Africa & Asia expansion." }
                                ]
                            },
                            {
                                title: "Seychelles",
                                items: [
                                    { text: "Cost-efficient PSP licensing for startups." }
                                ]
                            },
                            {
                                title: "Panama",
                                items: [
                                    { text: "Flexible payments regulatory environment." }
                                ]
                            },
                            {
                                title: "UAE",
                                items: [
                                    { text: "EMI & FinTech licenses via DIFC, ADGM, and Free Zones." }
                                ]
                            },
                            {
                                title: "Gibraltar",
                                items: [
                                    { text: "DLT framework and FinTech licensing, strong for crypto-payments." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of a Payments & FinTech License'
                        services={
                            [
                                {
                                    title: "Global Market Entry",
                                    text: "Operate cross-border financial services across multiple regions."
                                },
                                {
                                    title: "Institutional Trust",
                                    text: "Licensed entities attract investors, banks, and business partners."
                                },
                                {
                                    title: "Regulatory Compliance",
                                    text: "AML/KYC frameworks aligned with global standards."
                                },
                                {
                                    title: "Banking & Merchant Access",
                                    text: "Easier access to bank accounts and payment processors."
                                },
                                {
                                    title: "Crypto-Friendly",
                                    text: "Certain jurisdictions (Gibraltar, Mauritius, Seychelles) allow hybrid crypto-payment solutions."
                                }
                            ]
                        }
                    />

                    <LocationTimeline
                        title="General Requirements"
                        item={
                            [
                                {
                                    title: "Minimum Capital",
                                    text: "Varies by jurisdiction, e.g., €350k+ in EU jurisdictions."
                                },
                                {
                                    title: "Local Entity",
                                    text: "Incorporation in the chosen jurisdiction required."
                                },
                                {
                                    title: "Fit & Proper Management",
                                    text: "Directors and compliance officers must meet regulatory standards."
                                },
                                {
                                    title: "Compliance & Business Plan",
                                    text: "AML/KYC procedures, manuals, and policies prepared."
                                },
                                {
                                    title: "Annual Audit & Reporting",
                                    text: "Regulatory reporting obligations must be fulfilled annually."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Application Process'
                        features={
                            [
                                {
                                    title: "Consultation & Jurisdiction Selection",
                                    text: "Assess the best jurisdiction and license type for your business."
                                },
                                {
                                    title: "company-formation",
                                    text: "Establish the legal entity in the selected jurisdiction."
                                },
                                {
                                    title: "Compliance Documentation",
                                    text: "Prepare AML/KYC manuals, policies, and business plan."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Submit the complete application to the regulatory authority."
                                },
                                {
                                    title: "Regulatory Review & Approval",
                                    text: "Regulator performs due diligence and reviews compliance."
                                },
                                {
                                    title: "License Issuance & Launch",
                                    text: "Once approved, the business can operate under the license."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline'
                        items={[
                            {
                                duration: "EU Jurisdictions: 6–12 months",
                            },
                            {
                                description: ", Offshore Jurisdictions: 2–3 months",
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in EMI/PSP/MSB license applications" },
                                { text: "Experience with crypto-payment hybrid solutions" },
                                { text: "Global partnerships with banks & payment providers" },
                                { text: "End-to-end service from incorporation to license approval" },
                                { text: "Comparative analysis of EU Tier-1 vs Offshore Flexible Licenses" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    
                    <CTA
                        title="Ready to launch your PSP, EMI, or FinTech company?"
                        description="Offshore Advisory provides turnkey licensing solutions across Malta, Cyprus, Mauritius, Seychelles, Panama, UAE, and Gibraltar."
                        buttonText="Book a Free Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Which is the fastest jurisdiction for PSP/EMI licensing?",
        content: [
            { type: "answer", text: "Seychelles and Mauritius offer faster approvals, while EU jurisdictions (Malta, Cyprus) take longer but provide higher credibility." },
        ],
    },
    {
        question: "Can a PSP license cover crypto payments?",
        content: [
            { type: "answer", text: "Yes, in certain jurisdictions (Gibraltar, Seychelles, Mauritius) where regulators permit hybrid operations." },
        ],
    },
    {
        question: "Do I need a local office or director?",
        content: [
            { type: "answer", text: "Yes, in most jurisdictions local presence is mandatory." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "EU: €350k+ for EMI, €125k+ for PSP. Offshore: lower or negotiable." },
        ],
    },
    {
        question: "Can Offshore Advisory help open bank accounts?",
        content: [
            { type: "answer", text: "Yes, we connect licensed entities with banks, EMIs, and payment processors worldwide." },
        ],
    },
];
